require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-cookies/index.js
// module id = ./node_modules/angular-cookies/index.js
// module chunks = 1